import * as React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '../ui/table';
import { cn } from '../../lib/utils';
import { LoadingSpinner } from './LoadingSpinner';
import { EmptyState } from './EmptyState';
import { FileX } from 'lucide-react';

export const DataTable = ({ 
    columns, 
    data, 
    loading, 
    emptyMessage = 'No data available',
    emptyIcon = FileX,
    onRowClick,
    className 
}) => {
    if (loading) {
        return <LoadingSpinner />;
    }

    if (!data || data.length === 0) {
        return (
            <EmptyState 
                icon={emptyIcon}
                title={emptyMessage}
                description="Get started by adding new data"
            />
        );
    }

    return (
        <div className={cn('industrial-card overflow-hidden', className)} data-testid="data-table">
            <Table>
                <TableHeader>
                    <TableRow className="table-header border-b">
                        {columns.map((column, index) => (
                            <TableHead 
                                key={index} 
                                className={cn('table-cell', column.className)}
                            >
                                {column.header}
                            </TableHead>
                        ))}
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {data.map((row, rowIndex) => (
                        <TableRow 
                            key={row.id || rowIndex} 
                            className={cn(
                                'table-row',
                                onRowClick && 'cursor-pointer'
                            )}
                            onClick={() => onRowClick && onRowClick(row)}
                            data-testid={`table-row-${rowIndex}`}
                        >
                            {columns.map((column, colIndex) => (
                                <TableCell key={colIndex} className="table-cell">
                                    {column.render 
                                        ? column.render(row[column.accessor], row) 
                                        : row[column.accessor]
                                    }
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};
